
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { createContext, useContext } from 'react';

var MotionContext = createContext({});
function useVisualElementContext() {
    return useContext(MotionContext).visualElement;
}

export { MotionContext, useVisualElementContext };
//# sourceMappingURL=index.mjs.js.map
